import { useLayoutEffect } from 'preact/hooks';
import { useControls } from './useControls';

export function useUpdateTime(videoSlot: HTMLVideoElement) {
  const controls = useControls();

  useLayoutEffect(() => {
    function onTimeUpdate() {
      const remainingTime = videoSlot.duration - videoSlot.currentTime;
      controls.updateTime({
        duration: videoSlot.duration,
        remainingTime,
      });
    }

    videoSlot.addEventListener('timeupdate', onTimeUpdate);
    return () => videoSlot.removeEventListener('timeupdate', onTimeUpdate);
  }, []);
}
